var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-checkbox",on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('div',{ref:"wrapper",staticClass:"icon-wrapper",style:(_vm.cssVars)},[(_vm.value)?_c('Checked',{staticClass:"icon"}):_c('Unchecked',{staticClass:"icon"})],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }